import PropTypes from 'prop-types';
import React from 'react';
import ModalDialog, {
  ModalHeader,
  ModalFooter,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { hasKeyOnCustomPartnerUIPaint } from '@utils/company-helper';
import './ReloadModal.scss';
import { currentCompanyKeySelector } from '@selectors/company';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';

const ReloadModal = ({ isOpen, onClose, companyKey }) => {
  const handleReload = () => {
    window.location.reload(true);
  };

  const isCustomPartner = hasKeyOnCustomPartnerUIPaint();

  const getCompanyName = () => {
    switch (companyKey) {
      case 'loadsmith':
        return 'Loadsmith';

      case 'kamway':
        return 'Kam-Way';

      case 'transloop':
        return 'TransLoop';

      case 'surge':
        return 'Surge';

      default:
        return 'Parade';
    }
  };

  const renderHeader = () => (
    <ModalHeader>
      <h4 className="modal-heading">
        A new version of {getCompanyName()} is now available.
      </h4>
    </ModalHeader>
  );

  const renderFooter = props => (
    <ModalFooter showKeyline={props.showKeyline}>
      <span />
      <div className="actions">
        <Button onClick={onClose}>Update Later</Button>
        <Button
          appearance="primary"
          className={isCustomPartner && 'bg-amber'}
          onClick={handleReload}
        >
          Refresh Now
        </Button>
      </div>
    </ModalFooter>
  );

  return (
    <ModalTransition>
      {isOpen && (
        <ModalDialog
          components={{
            Header: renderHeader,
            Container: ({ children }) => (
              <div id="reload-modal">{children}</div>
            ),
            Footer: renderFooter,
          }}
          shouldCloseOnEscapePress={false}
          shouldCloseOnOverlayClick={false}
          scrollBehavior="outside"
          onClose={onClose}
        >
          <p>
            Please refresh your web browser to view the latest changes (CTRL +
            SHIFT + R or CMD + SHIFT + R).
          </p>
        </ModalDialog>
      )}
    </ModalTransition>
  );
};

const mapStateToProps = createStructuredSelector({
  companyKey: currentCompanyKeySelector,
});

const enhance = compose(connect(mapStateToProps));

ReloadModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  showKeyline: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  companyKey: PropTypes.string,
};

export default enhance(ReloadModal);
